import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiCardValue(theme: Theme): ComponentStyle {
  return {
    componentName: 'kpiCardValue',
    variants: {
      sparkLiquidityLayer: {
        color: 'transparent',
        backgroundImage:
          'radial-gradient(103.52% 1308.64% at 8.98% 83.33%,#fff,#FF82DE,#C51FDB)',
        backgroundClip: 'text',
        fontSize: theme.sizes['7'],
        fontWeight: 500
      },
      sparkLend: {
        color: 'transparent',
        backgroundImage:
          'radial-gradient(103.52% 1308.64% at 8.98% 83.33%,#fff,#FFCD4D,#FF895D)',
        backgroundClip: 'text',
        fontSize: theme.sizes['7'],
        fontWeight: 500
      },
      savings: {
        color: 'transparent',
        backgroundImage:
          'radial-gradient(103.52% 1308.64% at 8.98% 83.33%,#fff,#FFEF79,#00C2A1)',
        backgroundClip: 'text',
        fontSize: theme.sizes['7'],
        fontWeight: 500
      },
      spk: {
        color: 'transparent',
        backgroundImage:
          'radial-gradient(103.52% 1308.64% at 8.98% 83.33%,#fff,#ffbb93,#ff895d)',
        backgroundClip: 'text',
        fontSize: theme.sizes['7'],
        fontWeight: 500
      },
      mainValue: {
        fontSize: theme.sizes[6]
      }
    }
  };
}
